import React from "react";
import CountUp from "react-countup";
import "./KeyFigures.css";
import bgImage from "../../assets/images/sections/keyfigures_bg.png";

const KeyFigures = () => {
    const figures = [
        { title: "Licenciés", value: 180 },
        { title: "Dirigeants", value: 12 },
        { title: "Équipes", value: 10 },
    ];

    return (
        <div className="key-figures-section" style={{ backgroundImage: `url(${bgImage})` }}>
            <div className="key-figures-overlay">
                <h2 className="key-figures-title">
                    Les <span className="italic-gold">chiffres</span> clés du club
                </h2>
                <div className="title-underline"></div>
                <div className="key-figures-cards">
                    {figures.map((figure, index) => (
                        <div key={index} className="key-figure-card">
                            <div className="key-figure-value">
                                <CountUp end={figure.value} duration={3} />
                            </div>
                            <div className="key-figure-underline"></div>
                            <p className="key-figure-title">{figure.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KeyFigures;
